/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TerminalDto
 */
export interface TerminalDto {
    /**
     * 
     * @type {string}
     * @memberof TerminalDto
     */
    externalId: string;
    /**
     * 
     * @type {TerminalDtoLatestStateEnum}
     * @memberof TerminalDto
     */
    latestState: TerminalDtoLatestStateEnum;
    /**
     * 
     * @type {string}
     * @memberof TerminalDto
     */
    pspTerminalId: string;
    /**
     * 
     * @type {string}
     * @memberof TerminalDto
     */
    batteryLevel?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TerminalDto
     */
    batteryLevelUpdated?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof TerminalDto
     */
    created?: Date | null;
    /**
     * 
     * @type {TerminalDtoLatestEventCodeEnum}
     * @memberof TerminalDto
     */
    latestEventCode?: TerminalDtoLatestEventCodeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof TerminalDto
     */
    name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TerminalDto
     */
    updated?: Date | null;
}


/**
 * @export
 */
export const TerminalDtoLatestStateEnum = {
    UNKNOWN: 'UNKNOWN',
    OK: 'OK',
    BUSY: 'BUSY',
    MAINTENANCE: 'MAINTENANCE',
    UNREACHABLE: 'UNREACHABLE',
    OUT_OF_ORDER: 'OUT_OF_ORDER'
} as const;
export type TerminalDtoLatestStateEnum = typeof TerminalDtoLatestStateEnum[keyof typeof TerminalDtoLatestStateEnum];

/**
 * @export
 */
export const TerminalDtoLatestEventCodeEnum = {
    PAYMENT_RESPONSE: 'PAYMENT_RESPONSE',
    SHUTDOWN: 'SHUTDOWN',
    BEGIN_MAINTENANCE: 'BEGIN_MAINTENANCE',
    END_MAINTENANCE: 'END_MAINTENANCE',
    OUT_OF_ORDER: 'OUT_OF_ORDER',
    INITIALISED: 'INITIALISED',
    NETWORK_CONNECTED: 'NETWORK_CONNECTED',
    NETWORK_DISCONNECTED: 'NETWORK_DISCONNECTED',
    REJECT: 'REJECT',
    SALE_WAKE_UP: 'SALE_WAKE_UP',
    COMPLETED: 'COMPLETED',
    ASK_GRATUITY: 'ASK_GRATUITY',
    GRATUITY_ENTERED: 'GRATUITY_ENTERED',
    TENDER_CREATED: 'TENDER_CREATED',
    CARD_PRESENTED: 'CARD_PRESENTED',
    CARD_INSERTED: 'CARD_INSERTED',
    WAIT_FOR_PIN: 'WAIT_FOR_PIN',
    PIN_ENTERED: 'PIN_ENTERED',
    CARD_REMOVED: 'CARD_REMOVED',
    CARD_SWIPED: 'CARD_SWIPED',
    PRINT_RECEIPT: 'PRINT_RECEIPT',
    TENDER_FINAL: 'TENDER_FINAL',
    WAIT_FOR_APP_SELECTION: 'WAIT_FOR_APP_SELECTION',
    APPLICATION_SELECTED: 'APPLICATION_SELECTED',
    ASK_SIGNATURE: 'ASK_SIGNATURE',
    CHECK_SIGNATURE: 'CHECK_SIGNATURE',
    SIGNATURE_CHECKED: 'SIGNATURE_CHECKED',
    PIN_DIGIT_ENTERED: 'PIN_DIGIT_ENTERED',
    RECEIPT_PRINTED: 'RECEIPT_PRINTED',
    ASK_DCC: 'ASK_DCC',
    DCC_ACCEPTED: 'DCC_ACCEPTED',
    DCC_REJECTED: 'DCC_REJECTED',
    BALANCE_QUERY_STARTED: 'BALANCE_QUERY_STARTED',
    BALANCE_QUERY_COMPLETED: 'BALANCE_QUERY_COMPLETED',
    LOAD_STARTED: 'LOAD_STARTED',
    LOAD_COMPLETED: 'LOAD_COMPLETED',
    PROVIDE_CARD_DETAILS: 'PROVIDE_CARD_DETAILS',
    CARD_DETAILS_PROVIDED: 'CARD_DETAILS_PROVIDED',
    DIAGNOSIS: 'DIAGNOSIS',
    INITIATE_DIAGNOSIS: 'INITIATE_DIAGNOSIS'
} as const;
export type TerminalDtoLatestEventCodeEnum = typeof TerminalDtoLatestEventCodeEnum[keyof typeof TerminalDtoLatestEventCodeEnum];


/**
 * Check if a given object implements the TerminalDto interface.
 */
export function instanceOfTerminalDto(value: object): value is TerminalDto {
    if (!('externalId' in value) || value['externalId'] === undefined) return false;
    if (!('latestState' in value) || value['latestState'] === undefined) return false;
    if (!('pspTerminalId' in value) || value['pspTerminalId'] === undefined) return false;
    return true;
}

export function TerminalDtoFromJSON(json: any): TerminalDto {
    return TerminalDtoFromJSONTyped(json, false);
}

export function TerminalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TerminalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'externalId': json['externalId'],
        'latestState': json['latestState'],
        'pspTerminalId': json['pspTerminalId'],
        'batteryLevel': json['batteryLevel'] === undefined ? undefined : json['batteryLevel'] === null ? null : json['batteryLevel'],
        'batteryLevelUpdated': json['batteryLevelUpdated'] === undefined ? undefined : json['batteryLevelUpdated'] === null ? null : (new Date(json['batteryLevelUpdated'])),
        'created': json['created'] === undefined ? undefined : json['created'] === null ? null : (new Date(json['created'])),
        'latestEventCode': json['latestEventCode'] === undefined ? undefined : json['latestEventCode'] === null ? null : json['latestEventCode'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'updated': json['updated'] === undefined ? undefined : json['updated'] === null ? null : (new Date(json['updated'])),
    };
}

export function TerminalDtoToJSON(json: any): TerminalDto {
    return TerminalDtoToJSONTyped(json, false);
}

export function TerminalDtoToJSONTyped(value?: TerminalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'externalId': value['externalId'],
        'latestState': value['latestState'],
        'pspTerminalId': value['pspTerminalId'],
        'batteryLevel': value['batteryLevel'],
        'batteryLevelUpdated': value['batteryLevelUpdated'] == null ? value['batteryLevelUpdated'] : value['batteryLevelUpdated'].toISOString(),
        'created': value['created'] == null ? value['created'] : value['created'].toISOString(),
        'latestEventCode': value['latestEventCode'],
        'name': value['name'],
        'updated': value['updated'] == null ? value['updated'] : value['updated'].toISOString(),
    };
}

